import { useState } from 'react';

const modules = [
  {
    title: "مدخل استراتيجي للهوية البصرية",
    items: [
      "مفهوم الهوية البصرية (Logo vs Identity vs Branding)",
      "دور الهوية في بناء البراند في السوق",
      "الفرق بين التصميم الجمالي والتصميم الاستراتيجي",
      "لماذا النظام البصري أهم من الشعار؟",
      "تحليل أمثلة هويات ناجحة (تفكيك وتحليل)"
    ]
  },
  {
    title: "تحليل البراند وفهم العميل (Brand Strategy)",
    items: [
      "قراءة وفهم الـ Client Brief",
      "استخراج: القيم (Values)، الرسالة (Mission)، الرؤية (Vision)",
      "تحليل الجمهور المستهدف (Target Audience)",
      "تحليل المنافسين (Competitor Analysis)",
      "تحديد شخصية البراند (Brand Personality)",
      "تحويل المعطيات إلى اتجاه تصميمي واضح"
    ]
  },
  {
    title: "توليد الأفكار وبناء الـ Concept",
    items: [
      "Word Mapping (ربط الكلمات بالمفاهيم)",
      "Brainstorming (توليد أفكار إبداعية)",
      "اختيار الاتجاه المناسب (Direction Selection)",
      "بناء Moodboard احترافي",
      "تحويل الـ Moodboard إلى Concept منطقي",
      "كتابة Concept واضح قابل للدفاع"
    ]
  },
  {
    title: "تصميم الشعار (Concept → Execution)",
    items: [
      "Sketching (التفكير بالرسم اليدوي)",
      "تطوير عدة أفكار (Concept Variations)",
      "اختيار أفضل Concept",
      "بناء الشعار باستخدام Grid System",
      "مبادئ الشعار الناجح",
      "اختبار الشعار (Scalability & Visibility)"
    ]
  },
  {
    title: "تطوير الشعار واتخاذ القرار",
    items: [
      "Refinement (تحسين التفاصيل)",
      "Iterations (التكرار والتطوير)",
      "مقارنة الحلول التصميمية",
      "اتخاذ القرار التصميمي الصحيح",
      "تبرير التصميم (Design Justification)",
      "بناء نسخة نهائية احترافية (Final Logo Package)"
    ]
  },
  {
    title: "بناء النظام البصري (Visual System)",
    items: [
      "بناء نظام الألوان (Color System): ألوان أساسية وثانوية، دلالات الألوان",
      "بناء نظام الخطوط (Typography System): Primary / Secondary Fonts",
      "تصميم العناصر البصرية: Shapes, Patterns, Icons",
      "استخدام Grid في بناء النظام",
      "تحقيق الاتساق البصري (Consistency)"
    ]
  },
  {
    title: "التناسق والمرونة في الهوية",
    items: [
      "كيف نحافظ على وحدة الهوية؟",
      "كيف نجعل الهوية مرنة للتطبيق؟",
      "قواعد الاستخدام (Do & Don’t)",
      "بناء نظام قابل للتوسع",
      "إدارة الهوية عبر منصات مختلفة"
    ]
  },
  {
    title: "تطبيقات الهوية البصرية",
    items: [
      "تطبيق الهوية على: Business Card, Social Media Designs",
      "اختيار التطبيقات المناسبة لكل براند",
      "استخدام Mockups بشكل احترافي (Photoshop)",
      "تحويل الهوية من فكرة إلى واقع بصري"
    ]
  },
  {
    title: "إعداد دليل الهوية (Brand Guidelines)",
    items: [
      "هيكلة دليل الهوية",
      "إخراج الملف بصيغة احترافية (PDF)"
    ]
  },
  {
    title: "التقديم وتجربة العميل (Client Experience)",
    items: [
      "إعداد Presentation احترافي",
      "سرد قصة المشروع (Design Storytelling)",
      "مهارات عرض العمل (Pitching)",
      "استقبال Feedback",
      "محاكاة تجربة عميل حقيقية"
    ]
  },
  {
    title: "المشروع النهائي والبورتفوليو",
    items: [
      "تنفيذ مشروع هوية متكامل",
      "تجهيز الملفات النهائية",
      "بناء Case Study احترافي",
      "إضافة المشروع للبورتفوليو",
      "عرض المشروع بشكل يقنع العملاء"
    ]
  }
];

export default function CourseContent() {
  const [openIndex, setOpenIndex] = useState(0); // Open the first one by default

  const toggleAccordion = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section id="course-content" className="py-24 relative overflow-hidden bg-white dark:bg-zinc-900 transition-colors duration-500">
      {/* Abstract Background Noise */}
      <div className="absolute inset-0 bg-[url('https://www.transparenttextures.com/patterns/stardust.png')] opacity-[0.03] dark:opacity-5 mix-blend-screen pointer-events-none transition-opacity duration-500"></div>

      <div className="container mx-auto px-4 relative z-10 w-full mb-16 text-center">
        <h2 className="text-lg font-bold text-primary-600 dark:text-primary-500 mb-3 uppercase tracking-widest inline-flex items-center gap-2">
          <span className="w-8 h-1 bg-primary-500 rounded-full"></span>
          المنهجية
          <span className="w-8 h-1 bg-primary-500 rounded-full"></span>
        </h2>
        <h3 className="text-4xl md:text-5xl font-extrabold text-slate-900 dark:text-white mb-6 leading-tight drop-shadow-sm dark:drop-shadow-md transition-colors duration-500">
          محتوى <span className="text-transparent bg-clip-text bg-gradient-to-l from-primary-600 to-primary-700 dark:from-primary-400 dark:to-primary-600">الدورة الشامل</span>
        </h3>
        <p className="text-lg md:text-xl text-slate-600 dark:text-zinc-400 font-light max-w-2xl mx-auto leading-relaxed transition-colors duration-500">
          رحلة تعليمية متكاملة مصممة بعناية لتنتقل بك من الأساسيات الاستراتيجية إلى التميز في بناء هويات بصرية حية واحترافية.
        </p>
      </div>

      <div className="container mx-auto px-4 relative z-10 w-full max-w-4xl">
        <div className="flex flex-col gap-4">
          {modules.map((module, index) => {
            const isOpen = openIndex === index;

            return (
              <div 
                key={index} 
                className={`group border rounded-2xl overflow-hidden transition-all duration-500 ${
                  isOpen 
                    ? 'border-primary-500/50 bg-slate-50 dark:bg-zinc-800/80 shadow-[0_10px_30px_rgba(224,0,0,0.08)] dark:shadow-[0_10px_40px_rgba(224,0,0,0.15)]' 
                    : 'border-slate-200 dark:border-white/10 bg-white dark:bg-zinc-900/40 hover:border-primary-500/30'
                }`}
              >
                <button
                  onClick={() => toggleAccordion(index)}
                  className="w-full text-right px-6 py-5 flex items-center justify-between focus:outline-none"
                >
                  <div className="flex items-center gap-4">
                    <div className={`flex items-center justify-center w-10 h-10 rounded-full font-bold text-lg transition-colors duration-500 shrank-0 ${
                      isOpen 
                        ? 'bg-primary-500 text-white shadow-[0_0_15px_#e00000]' 
                        : 'bg-slate-100 dark:bg-zinc-800 text-slate-500 dark:text-zinc-400 group-hover:text-primary-500 group-hover:bg-primary-50 dark:group-hover:bg-primary-900/20'
                    }`}>
                      {index + 1}
                    </div>
                    <h4 className={`text-lg md:text-xl font-bold transition-colors duration-500 ${
                      isOpen 
                        ? 'text-primary-700 dark:text-primary-400' 
                        : 'text-slate-800 dark:text-zinc-200 group-hover:text-primary-600 dark:group-hover:text-primary-400'
                    }`}>
                      {module.title}
                    </h4>
                  </div>
                  
                  <div className={`flex items-center justify-center w-8 h-8 rounded-full transition-all duration-500 transform ${
                    isOpen ? 'rotate-180 bg-primary-100 dark:bg-primary-900/30 text-primary-600 dark:text-primary-400' : 'bg-slate-50 dark:bg-zinc-800/50 text-slate-400'
                  }`}>
                    <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                    </svg>
                  </div>
                </button>

                <div 
                  className={`overflow-hidden transition-all duration-500 ease-in-out ${
                    isOpen ? 'max-h-[500px] opacity-100' : 'max-h-0 opacity-0'
                  }`}
                >
                  <div className="px-6 pb-6 pt-2 pl-6 md:pl-16 mr-14 border-t border-slate-100 dark:border-white/5 mx-6">
                    <ul className="space-y-3 mt-4">
                      {module.items.map((item, itemIndex) => (
                        <li key={itemIndex} className="flex items-start gap-3">
                          <span className="flex-shrink-0 mt-1.5 w-1.5 h-1.5 rounded-full bg-primary-500"></span>
                          <span className="text-slate-600 dark:text-zinc-400 leading-relaxed font-medium">{item}</span>
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
